import { useMemo } from 'react';

import { SlotsProvider } from '~/components/providers';
import { useLayout } from '~/hooks/use-config';
import { Modal } from './modal';
import { renderChild } from './utils';

type Props = React.PropsWithChildren;

export const Layout = (_props: Props) => {
  const layout = useLayout();
  const slots = useMemo(() => ({}), []);

  return (
    <>
      <SlotsProvider slots={slots}>{layout.map(renderChild)}</SlotsProvider>
      <Modal />
    </>
  );
};
